import { useMemo } from 'react'

import type { CatalogFilteringState } from 'views/Catalog/LandingPage/Catalog'

import { useGroupedIntegrationsQuery } from '@segment/api/routes/catalog/queries'

import useNextPageTrigger from '@segment/utils/useNextPageTrigger'

interface UseGroupedGridProps {
  filteringState: CatalogFilteringState
}

const useGroupedGrid = ({ filteringState }: UseGroupedGridProps) => {
  const groupedQueryData = useGroupedIntegrationsQuery({
    args: [filteringState],
    options: {
      enabled: filteringState.query === ``,
    },
  })
  const groupedQueryDataFlattenedPages = useMemo(
    () => groupedQueryData.data?.pages.flatMap((page) => page.hits),
    [groupedQueryData.data?.pages]
  )
  return {
    hasNextPage: groupedQueryData.hasNextPage,
    isEmpty:
      !groupedQueryData.isLoading &&
      !groupedQueryData.hasNextPage &&
      groupedQueryDataFlattenedPages &&
      groupedQueryDataFlattenedPages?.length === 0,
    nextPageTrigger: useNextPageTrigger({
      isLoading: groupedQueryData.isLoading,
      totalDownloadedPages: groupedQueryData.data?.pages.length ?? -1,
      hasNextPage: groupedQueryData.hasNextPage ?? false,
      onNextPage() {
        groupedQueryData.fetchNextPage?.()
      },
      loadMargin: `0%`,
    }),
    groupedQueryDataFlattenedPages,
  }
}

export default useGroupedGrid
